import Vue from 'vue';
import router from './router/index';
import Vant from 'vant';
import 'vant/lib/index.css';
import { Notify } from 'vant';
import utils from './utils';
import './config/index.js';
import App from './App.vue';
import { NavBar } from 'vant';
import { Icon } from 'vant';
import vueToTop from 'vue-totop';
import vuex from 'vuex';
import infiniteScroll from 'vue-infinite-scroll';
import { Lazyload } from 'vant';
import store from './store';
// import vConsole from 'vconsole';
import { Dialog } from 'vant';
import VueLazyload from 'vue-lazyload'
import VueVideoPlayer from 'vue-video-player'
import { Step, Steps } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import '@/mixins/setcookie'
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import '@/styles/vant-ui.less'
Sentry.init({
  dsn: 'https://bf2432f68ae44f84a36b3dfa6d2823e5@sentry.jmzgo.com/4',
  integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
});

// let Console = new vConsole();
// Vue.use(Console);
Vue.use(Lazyload);
Vue.use(VueVideoPlayer)
Vue.use(infiniteScroll);
Vue.use(vuex);
Vue.use(vueToTop);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Vant);
Vue.use(utils);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(VueLazyload);
Vue.use(Steps);
Vue.use(Step);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.config.productionTip = false;
Vue.prototype.$wx=window.wx
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
